import React, { useState, useEffect, useRef } from "react";
import {Row, Container, Col, Form, Button, Modal, Table } from "react-bootstrap";
import LeftIndent from "utils/LeftIndent";
import CustomTooltip from "utils/CustomTooltip";
import DeleteOrgModal from "./DeleteOrgModal";


export default function OrgStatus(props) {
  const createNewOrgUrl = "/datapulse/org-management/new-org"
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({});
  const [deleteLocked, setDeleteLocked] = useState(true);
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const confirmDelete = (org) => {
    setDeleteTarget(org)
    setShowCreateModal(false)
    setShowDeleteModal(true)
  }

  const deleteOrg = (org) => {
    $.ajax({
      type: "POST",
      url: "/datapulse/org-management/remove-org/" + org.id,
    });
  }

  return (
    <>
      <div className="standard-page-padding">
        <h1>Organization Management</h1>
          <div className="d-flex justify-content-end mb-4">
            <Button className="lite-btn btn-success" onClick={(e) => setShowCreateModal(true)}>
              +&nbsp;&nbsp;New Organization
            </Button>
          </div>
          <div className="table-responsive org-management-table">
            <table>
              <thead>
                <tr>
                  <th style={{minWidth: "150px", paddingLeft: "1rem"}}>Name</th>
                  <th style={{minWidth: "150px"}}>Creation Date</th>
                  <th style={{minWidth: "225px"}}></th>
                </tr>
              </thead>
              <tbody>
                {props.orgs.map((org) => {
                  return (
                    <tr className="" key={org.id} style={{height: "50px"}}>
                      <td style={{paddingLeft: "1rem"}}>{org.name}</td>
                      <td>{new Date(Date.parse(org.created_at)).toLocaleDateString()}</td>
                      <td style={{textAlign: "right", paddingRight: "1rem"}}>
                        <a
                          className="mr-3"
                          href={`/datapulse/organization/${org.id}`}
                        >
                          <button className="lite-btn lite-btn-sm btn-code">
                          View
                          </button>
                        </a>
                        <button 
                          style={{visibility: !org.name.includes("Digital Position") ? "visible" : "hidden"}} 
                          type= "button"
                          size="sm" 
                          className="lite-btn lite-btn-sm btn-danger"
                          variant="danger" 
                          onClick={() => confirmDelete(org)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
      </div>
      <Modal className="create-new-org-modal" show={showCreateModal} onHide={() => setShowCreateModal(false)} style={{ textAlign: "center" }}>
        <div className="page-1">
          <Modal.Header closeButton>
            {" "}
            <Row className="mb-2  justify-content-center" style={{ margin: "auto" }}>
              <Col>
                <h3 className="">What is the name of the organization?</h3>
              </Col>
            </Row>
          </Modal.Header>
          <Modal.Body>
            <Row className=" mb-5">
              <Col className="name-blurr">
                <p className="">
                  This is how your organization will be displayed in DataPulse.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center pb-2">
              <Col className="name-input">
                <Form className="create-new-org" method="post" action={createNewOrgUrl}>
                  <input hidden name="authenticity_token" value={authenticityToken} readOnly />
                  <input defaultValue="" className="lite-input" name="organization_name" style={{ width: "591px", maxWidth: "100%", marginBottom: "40px" }} required />
                  <Row>
                    <Col>
                      <button
                        type="submit"
                        style={{ width: "300px", maxWidth: "80%" }}
                        className="lite-btn btn-success btn btn-primary btn-lg"
                        >
                        Next
                      </button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </div>
      </Modal>
      <DeleteOrgModal 
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        deleteTarget={deleteTarget}
        setDeleteLocked={setDeleteLocked}
        deleteOrg={deleteOrg}
        deleteLocked={deleteLocked}
      />
    </>
  );
}

